import React, { useEffect, useState } from "react";
// 🔧 YOL DÜZELTİLDİ: ../../ → ../../../
import { adminAction, adminListThreats } from "../../../common/security/api";

import { getAuth } from "firebase/auth";

export default function ThreatList(){
  const [rows, setRows] = useState([]);
  const [settings, setSettings] = useState({ siteWideCapy:false });
  const [search, setSearch] = useState("");
  const [ipInput, setIpInput] = useState("");
  const [fpInput, setFpInput] = useState("");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(()=>{
    const unsub = getAuth().onAuthStateChanged(u => setEmail(u?.email || ""));
    return ()=>unsub();
  }, []);

  const load = async ()=>{
    if (!email) return;
    setErr("");
    const j = await adminListThreats(email).catch((error)=>({ ok:false, error: error?.message || String(error) }));
    if (j.ok){
      setRows(j.items||[]);
      setSettings(j.settings||{ siteWideCapy:false });
    } else {
      setErr(j.error || "Tehdit listesi yuklenemedi.");
    }
  };
  useEffect(()=>{ load(); /* eslint-disable-next-line */ },[email]);

  const act = async (payload)=>{
    try{
      setBusy(true);
      setErr("");
      const result = await adminAction(email, payload);
      if (result && result.ok === false) throw new Error(result.error || "Islem basarisiz.");
      await load();
    } catch (error) {
      setErr(error?.message || String(error));
    } finally {
      setBusy(false);
    }
  };

  const filtered = rows.filter(r=>{
    const s = search.toLowerCase();
    const line = [r.ip,r.path,r.reason,r.status,r.fingerprint||""].join(" ").toLowerCase();
    return !s || line.includes(s);
  });

  return (
    <div style={{ padding:20 }}>
      <h2>🛡️ Tehdit Listesi</h2>

      <div style={{ marginBottom:10 }}>
        <input
          style={{ width:"100%", maxWidth:420, padding:8, border:"1px solid #e5e7eb", borderRadius:8 }}
          placeholder="Ara (ip, fingerprint, path, reason, status)..."
          value={search} onChange={e=>setSearch(e.target.value)}
        />
        <button style={{ marginLeft:8, padding:"8px 12px" }} onClick={load}>Yenile</button>
      </div>

      {err && (
        <div style={{ marginBottom:12, padding:10, color:"#991b1b", background:"#fee2e2", border:"1px solid #fecaca", borderRadius:8 }}>
          {err}
        </div>
      )}

      <div style={{ marginBottom:12, padding:10, border:"1px dashed #cbd5e1", borderRadius:8 }}>
        <b>Tüm Siteye Capy</b>: {settings.siteWideCapy ? "AÇIK" : "KAPALI"}{" "}
        <button
          style={{ marginLeft:10, padding:"6px 10px" }}
          onClick={()=>act({ action:"siteWideCapy", value: !settings.siteWideCapy })}
          disabled={busy}
        >
          {busy ? "..." : (settings.siteWideCapy ? "Kapat" : "Aç")}
        </button>
      </div>

      <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
        <thead>
          <tr style={{ background:"#f8fafc" }}>
            {["IP","Fingerprint","Dizin","Sebep","Durum","Sayı","Capy","Son Deneme","İşlem"].map(h=>(
              <th key={h} style={{ padding:8, border:"1px solid #e5e7eb", textAlign:"left" }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {filtered.map(r=>(
            <tr key={r.id}>
              <td style={td}>{r.ip}</td>
              <td style={td}>{r.fingerprint || "-"}</td>
              <td style={td}>{r.path}</td>
              <td style={td}>{r.reason}</td>
              <td style={td}>{r.status}</td>
              <td style={td}>{r.count || 0}</td>
              <td style={td}>{r.capyApplied ? "Capy uygulandı" : "-"}</td>
              <td style={td}>{r.lastAttemptAt?.toDate?.()?.toLocaleString("tr-TR") || "-"}</td>
              <td style={td}>
                {r.capyApplied ? (
                  <button onClick={()=>act({ action:"removeCapy", id:r.id })}>Capy kaldır</button>
                ) : (
                  <button onClick={()=>act({ action:"applyCapy", id:r.id })}>Capy uygula</button>
                )}
                <button style={{ marginLeft:6 }} onClick={()=>act({ action:"banIp", id:r.id })}>IP Banla</button>
                {!!r.fingerprint && (
                  <button style={{ marginLeft:6 }} onClick={()=>act({ action:"banFp", id:r.id })}>Cihazı Banla</button>
                )}
              </td>
            </tr>
          ))}
          {!filtered.length && <tr><td style={{ padding:10, color:"#64748b" }} colSpan={9}>(Kayıt yok)</td></tr>}
        </tbody>
      </table>

      <div style={{ marginTop:12 }}>
        <h4>🔧 Hızlı İşlemler</h4>
        <div style={{ display:"flex", gap:8, marginTop:8, flexWrap:"wrap" }}>
          <input placeholder="IP adresi" value={ipInput} onChange={e=>setIpInput(e.target.value)}
                 style={{ flex:"1 1 240px", padding:8, border:"1px solid #e5e7eb", borderRadius:8 }} />
          <button onClick={()=>act({ action:"banIp", ip:ipInput })}>IP Banla</button>
          <button onClick={()=>act({ action:"unbanIp", ip:ipInput })}>IP Banı Kaldır</button>

          <input placeholder="Fingerprint" value={fpInput} onChange={e=>setFpInput(e.target.value)}
                 style={{ flex:"1 1 240px", padding:8, border:"1px solid #e5e7eb", borderRadius:8 }} />
          <button onClick={()=>act({ action:"banFp", fingerprint:fpInput })}>Cihazı Banla</button>
          <button onClick={()=>act({ action:"unbanFp", fingerprint:fpInput })}>Cihaz Banını Kaldır</button>
        </div>
      </div>
    </div>
  );
}
const td = { padding:8, border:"1px solid #eef2f7" };
